import { useMemo } from 'react';
import { Column } from '~/commonComponents/Column';
import { IRecentProfessional } from '~/domain/RecentProfessionals';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';
import { NoWorkedWith } from './NoWorkedWith';

export const RecentProfessionalTabPanel = ({
  isLoading,
  selectedProfessionals,
  onSelectProfessionals,
  profession,
  data = [],
  isNewDesign,
  onViewSkills,
  allSelectableIds,
}: IProfessionalTabPanelProps<IRecentProfessional>) => {
  const professionals = useMemo(() => {
    return data?.map(
      (it) =>
        ({
          ...it,
          id: it?.professional?.id,
          full_name: it?.professional?.fullName,
          isAvailable: it?.isAvailable ?? true,
          profession: it?.profession,
          profile_image: it?.professional?.image,
          professions: it?.professional?.professions,
          rating: {
            averageRating:
              it?.professional?.overallProfessionalRating?.averageRating,
            professionalSkills:
              it?.professional?.overallProfessionalRating?.averageProfessionalSkills,
            interpersonalSkills:
              it?.professional?.overallProfessionalRating?.averageInterpersonalSkills,
            timeManagement:
              it?.professional?.overallProfessionalRating?.averageTimeManagement,
          },
          badges: it?.professional?.badges ?? [],
          education: it?.professional?.education ?? {},
        }) as IRecentProfessional,
    );
  }, [data]);

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Column flex={1}>
      <ProfessionalList
        DescriptionComponent={
          <>
            These are professionals who have recently worked at your office.
            <br />
            They will be confirmed once they accept the offer as listed.
          </>
        }
        EmptyComponent={<NoWorkedWith />}
        isEmpty={isEmpty}
        isLoading={isLoading}
        // @ts-expect-error -- Wrong type
        professionals={professionals}
        selectedProfessionals={selectedProfessionals}
        selectedProfession={profession}
        onSelectProfessionals={onSelectProfessionals}
        isNewDesign={isNewDesign}
        onViewSkills={onViewSkills}
        allSelectableIds={allSelectableIds}
      />
    </Column>
  );
};
